/* eslint-disable no-undef */
import { createStore, applyMiddleware } from 'redux';

import thunk from 'redux-thunk';
import reducers from './reducers/index';

const configureStore = (initialState) => {
  const middlewares = [thunk];
  // middlewares.push(require('redux-logger').createLogger({ collapsed: true }));

  const store = createStore(
    reducers,
    initialState,
    applyMiddleware(...middlewares),
  );

  if (module.hot) {
    module.hot.accept('../reducers', () => store.replaceReducer(reducers));
  }

  return store;
};

export default configureStore;
